<cdk-accordion [multi]="multi" [ngClass]="class">
  @for (item of $any((accordionItems || [])); track item; let index = $index) {
    <cdk-accordion-item
      #accordionItem="cdkAccordionItem"
      tabindex="0"
      [ngClass]="item?.class ?? ''"
      [attr.id]="'accordion-header-' + index"
      [attr.aria-expanded]="accordionItem.expanded"
      [attr.aria-controls]="'accordion-body-' + index">
      <ng-container *ngTemplateOutlet="item.template; context: { expanded: accordionItem.expanded, accordionItem: accordionItem }"></ng-container>
    </cdk-accordion-item>
  }
</cdk-accordion>
